import { ArrowUpRight, Search, Star } from "lucide-react";
import Header from "./Header";
import { useEffect, useState } from "react";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import { fetchEvents } from "../Service/api";
import { useQuery } from "@tanstack/react-query";
import Pagination from "./pagination";
import { ClipLoader } from "react-spinners";
import moment from "moment/moment";
import Title from "./Title";

function Events() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [apiSearch, setApiSearch] = useState("");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const categories = [
    "All",
    "Concerts",
    "Live",
    "Sports",
    "Food",
    "Cycling",
    "Running",
    "Camping",
    "Rock Climbing",
    "Picnics",
    "Kayaking",
    "Arts Exhibition",
    "Museum Visits",
    "Hotels",
  ];

  const {
    data: events,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["events", currentPage, selectedCategory, apiSearch],
    queryFn: () =>
      fetchEvents(currentPage, {
        search: apiSearch.toLowerCase(),
        category:
          selectedCategory.toLowerCase() === "all"
            ? ""
            : selectedCategory.toLowerCase(),
      }),
  });

  function handleSubmit(e) {
    e.preventDefault();
    setApiSearch(search);
  }

  useEffect(() => {
    if (search === "") {
      setApiSearch("");
    }
  }, [search]);

  return (
    <div>
      <Title title="Events | Palynx" />
      <Header />
      <div className="web-max-container">
        <h1 className="events__heading">
          See all palynx <span>Events</span>
        </h1>
        {isError ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: "60vh",
              marginTop: "80px",
            }}
          >
            <h2>An error occurred</h2>
          </div>
        ) : (
          <div className="list__events__cont">
            <div className="events__search__container">
              <h4>All events</h4>
              <form onSubmit={handleSubmit} className="events__searchbox">
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  placeholder="Search"
                />
                <button>
                  <Search color="#67655E" />
                </button>
              </form>
            </div>
            <div className=" events__tag__cont no-scrollbar">
              {categories.map((category, index) => (
                <button
                  onClick={() => setSelectedCategory(category)}
                  key={index}
                  className={`category__btn ${
                    selectedCategory === category
                      ? "btn__active"
                      : "btn__inactive"
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: "300px",
                  marginTop: "80px",
                }}
              >
                <ClipLoader color="#36d7b7" size={50} />
              </div>
            ) : (
              <>
                <div className="events__card__cont">
                  {events.data.data.length ? (
                    events.data.data.map((eventDetails, index) => (
                      <EventCard
                        id={eventDetails?.id}
                        key={index}
                        title={eventDetails?.event_name}
                        place={eventDetails?.address}
                        date={eventDetails?.event_dates[0].event_date}
                        time={eventDetails?.event_dates[0].time}
                        tag={eventDetails?.hash_tags}
                        img={eventDetails?.event_images[0]?.event_image_url}
                      />
                    ))
                  ) : (
                    <h3 style={{ textAlign: "center" }}>No Events Found</h3>
                  )}
                </div>

                {events.data.pagination_meta.last_page > 1 && (
                  <Pagination
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                    totalPages={events.data.pagination_meta.last_page}
                  />
                )}
              </>
            )}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export function EventCard({ img, title, rating, place, date, tag, id, time }) {
  const formatDate = (dateString) => {
    return moment(dateString).format("MMMM Do YYYY");
  };
  return (
    <div className="event__card">
      <div className="event__img__cont">
        <img src={img} alt="eventImg" />
        <span>{tag}</span>
      </div>
      <div className="event__details__cont">
        <Link to={`/event/${id}`} className="event__title__cont">
          <h2>{title}</h2>
          <ArrowUpRight className="pt-1" width={32} height={32} />
        </Link>
        {rating && (
          <div className="event__rating">
            <Star fill="#E66C11" color="#E66C11" />
            <p>rating</p>
          </div>
        )}
        <p className="event_place__date">
          {place} <br />
          {`${formatDate(date)} (${time})`}
        </p>
      </div>
    </div>
  );
}

export default Events;
